import React from 'react';
import styled from 'styled-components';

const TopBox = styled.div`
  width: 100%;
  padding: 18px 0 8px 0;
  text-align: center;
`;

const HeadTitleText = styled.h1`
  tex-align: center;
  font-size: 2.4rem;
  font-weight: 600;
  margin: 0;
  color: #3a3a3a;
  word-break: keep-all;
`;

const HeadText = styled.p`
  margin-top: 8px;
  font-size: 14px;
  color: #666;
  font-weight: 400;
  margin-bottom: 0;
`;

type TitleHeaderProps = {
  title: string;
  subTitle?: string;
};

function TitleHeader(props: TitleHeaderProps) {
  const { title, subTitle } = props;
  return (
    <TopBox>
      <HeadTitleText>{title}</HeadTitleText>
      {subTitle && <HeadText>{subTitle}</HeadText>}
    </TopBox>
  );
}

export default TitleHeader;
